import { Button } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { EyeIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
interface HiddenAnswerNoticeProps {
  onReveal: () => void;
}

/** 정답 숨김 상태에서 1번 문제 카드에만 보이는 안내 */
export const HiddenAnswerNotice = ({
  onReveal
}: HiddenAnswerNoticeProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex min-h-[54px] w-full items-center gap-xs rounded-sm border border-opacity-assistive bg-neutral px-md py-sm" data-sentry-component="HiddenAnswerNotice" data-sentry-source-file="HiddenAnswerNotice.tsx">
      <p className="min-w-0 flex-1 text-body-lg-semibold text-neutral">
        {t('common:detail.answersHiddenNotice')}
      </p>
      <Button size="xs" variant="outlined" intent="neutral" className="shrink-0" leftSlot={<EyeIcon size="xs" fill={ICON_COLOR.neutral} />} onClick={onReveal} data-sentry-element="Button" data-sentry-source-file="HiddenAnswerNotice.tsx">
        {t('common:detail.showAnswers')}
      </Button>
    </div>;
};